import downloaderFor from './downloaderFor'

/**
 * Een export met de datum van vandaag in de bestandsnaam, in het formaat dat de
 * gebruiker in het exportvenster koos (`ExportModal` → `selection.format`).
 * Gedeeld door de aanwezigheidsexport en de notitie-export, zodat die twee de
 * naam en de keuze tussen Excel en CSV op dezelfde manier maken.
 *
 * De datum gaat via `toISOString`, zoals deze exports altijd deden.
 *
 * @param {Array<Record<string, any>>} rows - De rijen om te exporteren
 * @param {object} options
 * @param {string} options.prefix - Begin van de bestandsnaam, bijv. 'Aanwezigheid'
 * @param {'xlsx' | 'csv'} options.format - Gekozen bestandsformaat
 * @param {string[]} options.header - Kolomvolgorde
 * @param {Date} [options.now] - Voor de datum in de naam; standaard nu
 * @returns {boolean} false wanneer er niets te exporteren viel
 */
const downloadDatedExport = (rows, { prefix, format, header, now = new Date() }) => {
    // Zelfde regel als downloaderFor: alles wat geen 'xlsx' is, wordt een csv.
    const extension = format === 'xlsx' ? 'xlsx' : 'csv'
    return downloaderFor(format)(rows, `${prefix}-${now.toISOString().slice(0, 10)}.${extension}`, header)
}

export default downloadDatedExport
